export default [
    {
        path: "/festival",
        name: "Festival",
        meta: {
          title: "特色慰问",
          keepAlive: false,
          auth: false,
          home: false,
          backgroundColor: "#fff"
        },
        component: () => import("@views/external/Festival.vue")
    }, 
    {
        path: "/festival/1",
        name: "FestivalList",
        meta: {
          title: "儿童节",
          keepAlive: true,
          auth: false,
          home: false,
          backgroundColor: "#fff"
        },
        component: () => import("@views/external/FestivalList.vue")
    }, 
    {
        path: "/festival/2",
        name: "Summer",
        meta: {
          title: "夏日清凉",
          keepAlive: true,
          auth: false,
          home: false,
          backgroundColor: "#fff"
        },
        component: () => import("@views/external/FestivalSummer.vue")
    }, 
    // {
    //     path: "/festival/3",
    //     name: "FoundAParty",
    //     meta: {
    //       title: "100周年",
    //       keepAlive: true,
    //       auth: false,
    //       home: false,
    //       backgroundColor: "#fff"
    //     },
    //     component: () => import("@views/external/FoundAParty.vue")
    // }, 
    {
        path: "/festival/4",
        name: "SanBaFuNvJie",
        meta: {
          title: "3.8女神节快乐",
          keepAlive: true,
          auth: false,
          home: false,
          backgroundColor: "#fff"
        },
        component: () => import("@views/external/FestivalSanBaFuNvJie.vue")
    },
    {
        path: "/festivalCart",
        name: "FestivalCart",
        meta: {
            title: "购物车",
            keepAlive: true,
            footer: false,
            auth: true,
            home:false,
            festivalFooter: true
        },
        component: ()=> import("@views/shop/ShoppingCart")
    }, {
        path: "/festivalUser",
        name: "FestivalUser",
        meta: {
            title: "个人中心",
            keepAlive: true,
            footer: true,
            auth: true,
            home: false,
            festivalFooter: true
        },
        component: ()=> import("@views/user/User")
    }
];